import type { TJobsState } from '@/types/state-types/TJobsState'
import { CalendarEvent, JobForm } from '@/models'

export default <TJobsState>{
  jobForm: new JobForm(),
  jobDetails: new JobForm(),
  isLoading: false,
  hasIncomingJobChanges: false,
  unscheduledJobs: [] as CalendarEvent[],
  oneTimeJobTask: null
}
